import React, { FC } from 'react';

import { Formik, Form, Field } from 'formik';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import useRoleFlags from 'hooks/auth/useRoleFlags';

import {
    FormulaCloneOptionLabels,
    FormulaCloneOptions,
} from '../../models/formula.model';

import BasicButton from '../buttons/basicButton';

interface MessageCloneFormProps {
    onSubmit: (values: { options: FormulaCloneOptions[] }) => void;
    onCancel: () => void;
    isSubmitting?: boolean;
}

const MessageCloneForm: FC<React.PropsWithChildren<MessageCloneFormProps>> = ({
    onSubmit,
    onCancel,
    isSubmitting = false,
}) => {
    const { hasCreateFormulaAccess } = useRoleFlags();
    return (
        <Container>
            <Formik initialValues={{ options: [] }} onSubmit={onSubmit}>
                <Form>
                    <Label>Select all the options you want to clone</Label>
                    <Options>
                        {Object.values(FormulaCloneOptions).map((option) => (
                            <Option key={option}>
                                <Field
                                    type={'checkbox'}
                                    name={'options'}
                                    value={option}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                    disabled={
                                        isSubmitting || !hasCreateFormulaAccess
                                    }
                                />
                                <Value>
                                    {FormulaCloneOptionLabels[option]}
                                </Value>
                            </Option>
                        ))}
                    </Options>
                    <Buttons>
                        <BasicButton
                            isPrimary={false}
                            name={'Cancel'}
                            action={onCancel}
                            style={{ width: '100%' }}
                            disabled={isSubmitting}
                        />

                        <BasicButton
                            isPrimary
                            name={'Clone'}
                            type={'submit'}
                            style={{ width: '100%' }}
                            isLoading={isSubmitting}
                            isDisabled={!hasCreateFormulaAccess}
                        />
                    </Buttons>
                </Form>
            </Formik>
        </Container>
    );
};

const Container = styled.div(() => ({
    padding: 10,
}));

const Label = styled.span(() => ({
    color: aampeTheme.colors.gray600,
    fontSize: '20px',
    fontWeight: 800,
}));

const Options = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
    paddingBottom: aampeTheme.spacing(2),
    paddingTop: aampeTheme.spacing(3),
}));

const Option = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(1),
}));

const Value = styled.span(() => ({
    color: aampeTheme.colors.gray800,
    fontSize: '14px',
    fontWeight: 400,
}));

const Buttons = styled.div(() => ({
    marginTop: aampeTheme.spacing(2),
    padding: aampeTheme.spacing(0, 2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
}));

export default MessageCloneForm;
